import React, { useState, useEffect } from 'react';
import { Box, Button, CardMedia, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const WhatsappSection = () => {
  const [scrollValue, setScrollValue] = useState(0);
  // console.log(scrollValue);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setScrollValue(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <Stack
      position="fixed"
      zIndex={1}
      width="100%"
      className={`floating-card ${scrollValue >= 250 ? 'active' : ''} floating-inspection-card ${
        scrollValue >= 250 ? 'active' : ''
      }`}
      direction="row"
      gap={1}
      sx={{
        p: 2,
        background: 'linear-gradient(to right, rgba(217, 217, 217, 0.4), #C6C6C6)',
      }}
    >
      <Box sx={{ width: '100%', borderRadius: '10px', overflow: 'hidden' }}>
        <Button
          onClick={() => navigate('/inspection-booking')}
          sx={{
            width: '100%',
            background: 'linear-gradient(to right, #F1761B, #FF5100)',
            color: '#FFFFFF',
            fontSize: '18px',
            fontWeight: 700,
            borderRadius: '10px',
            paddingY: '8px',
            letterSpacing: '1px',
            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
            '&:hover': {
              background: 'linear-gradient(to right, #e0651b, #e94600)',
            },
          }}
        >
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Typography fontWeight="700" fontSize="14px">
              Book FOCUS Certified Inspection!
            </Typography>
            <Typography fontSize="10px" fontWeight="400" textAlign="start">
              Inspection team will contact you soon.{' '}
            </Typography>
          </Box>
        </Button>
        <Box
          sx={{
            height: '15px',
            backgroundColor: '#c5550e',
            marginTop: '-10px',
            borderBottomLeftRadius: '10px',
            borderBottomRightRadius: '10px',
          }}
        />
      </Box>
      <a href="https://wa.me/918891940560" target="_blank" rel="noopener noreferrer">
        <CardMedia
          component="img"
          src="assets/images/Inspection/whatsapp.png"
          alt="Card Image"
          sx={{
            objectFit: 'contain',
            borderRadius: '10px',
            width: '55px',
            height: '55px',
          }}
        />{' '}
      </a>
    </Stack>
  );
};

export default WhatsappSection;
